import React, { Component } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import IconFilter from "../../assets/filter.svg";
import ReactPaginate from "react-paginate";
import { DownloadExcelReport, Search } from "../reusableComponent";
import { PATHS } from "../../constant";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { get } from "lodash";
import { getAllPRAGATI } from "../../actions/mom.action";
import { VISIBLE, STATUS } from "../../constant";
import CalendarFilter from "../calendarFilter/CalendarFilter";
import { isValidArray, scrollToPosition, getLocalstorage } from "../../helper";
import AgendaListWithLoader from "./PragatiListWithLoader";
import LoaderTemplate from "../../component/LoaderTemplate";
import { FilterLoader } from "../../component/LoadersTemplate";
import Pagination from "../Pagination";
import Select from "react-select";
import { AGENDA_FLAT_FILE } from "../../constant";
import { components } from "react-select";
import FilterComponent from "../FilterComponent";
import { IssueSearchSorting } from "../issueFilters/IssueSearchSorting";
import { getAgendaStakeHolderAction } from "../../actions/mom.action";
import PermissionHOC from "../PermissionHOC";
import DisplayByPermission from "../../component/DisplayByPermission";
import DisabledExcelIcon from "../../assets/disabledExcel.svg";
import {
  getDownloadAgendaListAction,
  clearAgendaListDownloadAction
} from "../../actions/dowloadExcelActions";
import { getAllPRAGATILists } from "../../services/apiServices";
import {
  getMeetingDetailsforPRAGATI,
  getMeetingDetailsAfterSearchforPRAGATI
} from "../../services/apiServices";
import request from "../../services/requestService";

let parentName = null;

const sortByArr = [
  {
    sortBy: "NAME",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Agenda</b> name
      </span>
    ),
    active: "agenda"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>Latest</b> created
      </span>
    ),
    active: "latest"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Old</b> created
      </span>
    ),
    active: "old"
  }
];

const params = {
  offset: 0,
  limit: 10
};

const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;

  if (Array.isArray(values)) {
    const plural = values.length === 1 ? "" : "s";
    values = `${values.length} Selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

class PragatiList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      paginationNo: "",
      checkboxes: [],
      isLoading: false,
      agendaListParams: { ...params },
      filterArrayName: [],
      sortStatus: false,
      agendaFlatFile: [],
      selectedValue: [],
      checkStatus: "",
      meetingDateFilterData: [],
      meetingDatecalender: false,
      displayLoader: true,
      filterTitle: "",
      cancel: 0,
      calenderDisplaytext: false,
      paginationloading: true,
      pragati_payload: {
        offset: 0,
        limit: 10,
        meetingTypes: ["DPIIT"]
        //   meetingTypes: [
        //     "PRAGATI"
        // ],
        //   agendaStages: [
        //     "CONCLUDED",
        //     "SCHEDULED"
        // ],
      },
      PRAGATI_LIST: "",
      PaginationData: "",
      meetingValue: "",
      PragatiList: "",
      searchValue: false,
      PragatiMeetDate: "",
      meetingDate: "",
      loading: true
    };
  }
  // componentDidMount = async () => {
  //   const { getAllPRAGATI, location } = this.props;
  //   const response = await request(
  //     getAllPRAGATILists(this.state.pragati_payload)
  //   );
  //   if (!get(location, "state.filterArray.createdDate")) {
  //     getAllPRAGATI(undefined, { offset: 0, limit: 10, meetingTypes: [
  //        "DPIIT"
  //    ] });
  //    }
  //   console.log(response)
  // };
  componentDidMount() {
    const { getAllPRAGATI, location } = this.props;
    if (!get(location, "state.filterArray.createdDate")) {
      //  getAllPRAGATI(undefined, { offset: 0, limit:10, meetingTypes: [
      //     "DPIIT"
      // ] });
      getAllPRAGATI(undefined, {
        offset: 0,
        limit: 10,
        meetingTypes: ["PRAGATI"],
        agendaStages: ["CONCLUDED", "SCHEDULED", "CANCELLED", "POSTPONED"]
      });
    }
    this.PRAGATI_LISTAPIcall();
  }
  PRAGATI_LISTAPIcall = async (agendaListParams, offset) => {
    //console.log(this.state.searchValue)
    // const originalObject = {
    //   offset: 0,
    //   limit: 10,
    //   meetingTypes: [
    //     "DPIIT"
    //   ]
    // };
    const originalObject = {
      offset: 0,
      limit: 10,
      agendaStages: ["CONCLUDED", "SCHEDULED", "CANCELLED", "POSTPONED"],
      meetingTypes: ["PRAGATI"]
    };
    const updatedObject = {
      ...originalObject,
      ...agendaListParams
    };
    // console.log(updatedObject)
    const response = await request(getAllPRAGATILists(updatedObject));
    this.setState(
      {
        PRAGATI_LIST: response.data.data.listDTO,
        displayLoader: false,
        PaginationData: response.data,
        paginationloading: false
      },
      () => {
        //console.log(this.state.PRAGATI_LIST)
      }
    );
    const response1 = await request(getMeetingDetailsforPRAGATI());
    //console.log(response1)
    this.setState({ PragatiList: response1.data });
    //return response.data.data.listDTO
  };
  PRAGATI_LISTSearchAPIcall = async (agendaListParams, offset) => {
    //console.log(this.state.searchValue)
    // const originalObject = {
    //   offset: 0,
    //   limit: 10,
    //   meetingTypes: [
    //     "DPIIT"
    //   ]
    // };
    if (
      this.state.meetingDate == "" ||
      this.state.meetingDate == null ||
      this.state.meetingDate == undefined
    ) {
      const originalObject = {
        offset: 0,
        limit: 10,
        agendaStages: ["CONCLUDED", "SCHEDULED", "CANCELLED", "POSTPONED"],
        meetingTypes: ["PRAGATI"]
      };
      const updatedObject = {
        ...originalObject,
        ...agendaListParams
      };
      const response = await request(getAllPRAGATILists(updatedObject));
      this.setState({
        PRAGATI_LIST: response.data.data.listDTO,
        displayLoader: false,
        PaginationData: response.data,
        paginationloading: false
      });
    } else {
      const originalObject = {
        offset: 0,
        limit: 10,
        agendaStages: ["CONCLUDED", "SCHEDULED", "CANCELLED", "POSTPONED"],
        meetingTypes: ["PRAGATI"],
        meetingDate: this.state.meetingDate
      };
      const updatedObject = {
        ...originalObject,
        ...agendaListParams
      };
      const response = await request(getAllPRAGATILists(updatedObject));
      this.setState({
        PRAGATI_LIST: response.data.data.listDTO,
        displayLoader: false,
        PaginationData: response.data,
        paginationloading: false
      });
    }
  };
  PRAGATI_LISTSearch_APIcall = async searchtext => {
    if (searchtext == undefined) {
      const response1 = await request(getMeetingDetailsforPRAGATI());
      this.setState({ PragatiList: response1.data });
    } else {
      const response1 = await request(
        getMeetingDetailsAfterSearchforPRAGATI(searchtext)
      );
      this.setState({ PragatiList: response1.data });
    }
  };
  PRAGATI_LISTAPIcallforMeet = async meetingValue => {
    //console.log(agendaListParams, offset)
    // const originalObject = {
    //   offset: 0,
    //   limit: 10,
    //   meetingTypes: [
    //     "DPIIT"
    //   ],
    //   meetingDate:meetingValue
    // };
    const originalObject = {
      offset: 0,
      limit: 10,
      agendaStages: ["CONCLUDED", "SCHEDULED", "CANCELLED", "POSTPONED"],
      meetingTypes: ["PRAGATI"],
      meetingDate: meetingValue
    };
    //console.log(originalObject)
    const response = await request(getAllPRAGATILists(originalObject));
    this.setState(
      {
        PRAGATI_LIST: response.data.data.listDTO,
        displayLoader: false,
        PaginationData: response.data,
        paginationloading: false,
        meetingDate: meetingValue
      },
      () => {
        //console.log(this.state.PRAGATI_LIST)
      }
    );
    const response1 = await request(getMeetingDetailsforPRAGATI());
    //console.log(response1)
    this.setState({ PragatiList: response1.data });
    //return response.data.data.listDTO
  };
  handleRemove = () => {
    this.setState({ filterTitle: "" });
  };
  handleCalendarFilterData = (data, flag, filterTitle, cancel) => {
    //console.log(filterTitle)
    if (cancel == 0) {
      this.setState(
        {
          meetingDateFilterData: data,
          meetingDatecalender: true,
          displayLoader: true,
          filterTitle: "",
          calenderDisplaytext: true,
          meetingDate: "",
          agendaListParams: { offset: 0, limit: 10 },
          PaginationData: []
        },
        () => {
          this.PRAGATI_LISTAPIcall({
            offset: 0,
            limit: 10
          });
          setTimeout(() => {
            this.setState({ meetingDatecalender: false });
          }, 700);

          //   this.PRAGATI_LISTAPIcall({offset: 0,limit: 10});
          // }
        }
      );
    } else if (filterTitle == undefined) {
      this.setState({
        meetingDateFilterData: data,
        meetingDatecalender: true,
        displayLoader: true,
        filterTitle: filterTitle,
        calenderDisplaytext: false,
        agendaListParams: { offset: 0, limit: 10 }
      });
      this.PRAGATI_LISTAPIcall({
        offset: 0,
        limit: 10
      });

      setTimeout(() => {
        this.setState({ meetingDatecalender: false, PaginationData: 0 });
      }, 700);
      // const {agendaListParams}=this.state;
      // //console.log()
      // const originalObject = {
      //   offset: 0,
      //   limit: 10
      // }
      // const isMatch = JSON.stringify(originalObject) === JSON.stringify(agendaListParams);
      // console.log(isMatch)
      // if(isMatch){
      //   this.PRAGATI_LISTAPIcall(originalObject);
      // }
      // else{
      //   this.PRAGATI_LISTAPIcall(agendaListParams);
      // }
    } else {
      this.setState({
        meetingDateFilterData: data,
        meetingDatecalender: true,
        displayLoader: flag,
        filterTitle: filterTitle,
        calenderDisplaytext: false,
        PaginationData: 0
      });
      this.PRAGATI_LISTAPIcallforMeet(cancel);
      setTimeout(() => {
        this.setState({ meetingDatecalender: false, displayLoader: false });
      }, 700);
    }
  };

  onClearDownload = () => {
    const { clearAgendaListDownloadAction } = this.props;
    clearAgendaListDownloadAction();
  };

  getAllPRAGATI = params => {
    const { getAllPRAGATI } = this.props;

    this.setState(
      prevState => ({
        agendaListParams: { ...prevState.agendaListParams, ...params }
      }),
      () => {
        const { agendaListParams } = this.state;
        console.log(agendaListParams);
        if (agendaListParams.search !== null) {
          this.setState({ searchValue: true });
        }
        agendaListParams.searchText = agendaListParams.search;
        if (!agendaListParams.searchText) {
          delete agendaListParams.searchText;
          delete agendaListParams.search;
        }

        this.PRAGATI_LISTSearchAPIcall({ ...agendaListParams });
        this.PRAGATI_LISTSearch_APIcall(agendaListParams.searchText);
      }
    );
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  clearAll = () => {
    this.setState(
      {
        agendaListParams: { ...params },
        filterArrayName: []
      },
      () => {
        this.getAllPRAGATI(params);
      }
    );
  };
  onPageChange = data => {
    let offset = Math.ceil(data.selected);
    this.setState({ paginationloading: true });
    const { agendaListParams } = this.state;
    this.setState({ agendaListParams: { ...agendaListParams, offset } }, () => {
      this.PRAGATI_LISTAPIcall({ ...agendaListParams, offset });

      scrollToPosition({ top: 0 });
    });
  };

  handleCheckbox = (filter, filterName) => {
    const filterData = this.postFilterData(filter, filterName);
    //console.log(filterData);
    this.getAllPRAGATI(filterData);
  };

  excludeBasedOnFilteredData(bubbleFilters, currentFiltersList) {
    if (
      !currentFiltersList ||
      currentFiltersList.length === 0 ||
      !bubbleFilters
    ) {
      return bubbleFilters;
    }

    let selectedFilters = [];

    for (let i in bubbleFilters) {
      let bubbleFilter = bubbleFilters[i];
      let bubbleKey = bubbleFilter.filterName;
      let currentFilter = currentFiltersList[bubbleKey];

      if (!currentFilter) {
        selectedFilters.push(bubbleFilter);
        continue;
      }

      let keys = currentFilter.values.map(filter => filter.key);

      if (keys.includes(bubbleFilter.key)) {
        selectedFilters.push(bubbleFilter);
      }
    }

    return selectedFilters;
  }

  onAgendaListDownload = (filter, filterNames) => {
    const {
      getDownloadAgendaListAction,
      selectedFilters = this.postFilterData(filter, filterNames)
    } = this.props;
    const { agendaFlatFile } = this.state;

    const updatedFilter = [];

    agendaFlatFile.map(option => {
      if (option.isAgenda !== undefined) {
        updatedFilter.push("isAgenda");
      }

      if (option.isIssues !== undefined) {
        updatedFilter.push("isIssues");
      }

      if (option.isProjects !== undefined) {
        updatedFilter.push("isProjects");
      }
    });

    const updatedFilters = { ...selectedFilters, updatedFilter };
    getDownloadAgendaListAction(undefined, updatedFilters);
  };

  onSelectChange = (value, name) => {
    const update = {};
    update[name] = value;
    this.setState(update);
  };

  postFilterData = (value, filterName) => {
    let { agendaListParams, filterArrayName } = this.state;
    let currentFilter = agendaListParams[filterName];

    const filter = this.isFiltersAlreadyApplied(
      filterArrayName,
      value,
      filterName
    );
    let val = null;

    // to keep issueListParams seperate we are rendering filterArray name here
    let newArr = [];
    if (!get(filter, "filter.displayName")) {
      newArr = [{ ...value, filterName }];
    } else {
      value.checked = false;
      filterArrayName.splice(get(filter, "index"), 1);
    }

    this.setState({
      filterArrayName: [...filterArrayName, ...newArr]
    });

    switch (filterName) {
      // in this case value is object
      case "recipientMinistry":
      case "recipientState":
      case "sponsoringMinistry":
      //case "pmiicInclude":
      case "createdBy":
      case "districtStateDept":
      case "sponsoringDepartment":
      case "sponsoringState":
      case "meetingTypes":
        currentFilter = currentFilter || [];
        val = currentFilter.indexOf(value.key) === -1;
        val
          ? currentFilter.push(value.key)
          : currentFilter.splice(currentFilter.indexOf(value.key), 1);
        !isValidArray(currentFilter) && delete agendaListParams[filterName];
        agendaListParams = isValidArray(currentFilter)
          ? {
              ...agendaListParams,
              [filterName]: currentFilter
            }
          : { ...agendaListParams };
        break;
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.indexOf(+value.key) === -1;
        val
          ? currentFilter.push(+value.key)
          : currentFilter.splice(currentFilter.indexOf(+value.key), 1);
        !isValidArray(currentFilter) && delete agendaListParams[filterName];
        agendaListParams = isValidArray(currentFilter)
          ? {
              ...agendaListParams,
              [filterName]: currentFilter
            }
          : { ...agendaListParams };
        break;

      case "agendaStages":
        currentFilter = currentFilter || [];
        val = currentFilter.indexOf(value.key) === -1;
        val
          ? currentFilter.push(value.key)
          : currentFilter.splice(currentFilter.indexOf(value.key), 1);
        !isValidArray(currentFilter) && delete agendaListParams[filterName];
        agendaListParams = isValidArray(currentFilter)
          ? {
              ...agendaListParams,
              [filterName]: currentFilter
            }
          : { ...agendaListParams };
        break;

      case "projectIdFilter":
        currentFilter = [];
        //console.log(currentFilter)
        val = currentFilter.indexOf(+value.key) === -1;
        val
          ? currentFilter.push(value)
          : currentFilter.splice(currentFilter.indexOf(+value.key), 1);
        !isValidArray(currentFilter) && delete agendaListParams[filterName];
        agendaListParams = isValidArray(currentFilter)
          ? {
              ...agendaListParams,
              [filterName]: currentFilter.toString()
            }
          : { ...agendaListParams };
        //console.log(agendaListParams)
        break;

      default:
        break;
    }

    return { ...agendaListParams, offset: 0 };
  };

  onClickingFlatFileDropDown() {
    const statesListOption = ["Agenda", "Pojects", "Issues"];
    //console.log("111111")
    return statesListOption;
  }

  removeFilter = filter => {
    const params = this.postFilterData(filter, filter.filterName);
    this.getAllPRAGATI(params);
  };

  // show applied filters
  isFiltersAlreadyApplied = (filterArr, filter, filterName) => {
    let currentIndex = 0;
    const filterApplied = filterArr.find((value, index) => {
      currentIndex = index;
      return (
        value.filterName === filterName &&
        value.displayName === filter.displayName
      );
    });
    return { filter: filterApplied, index: currentIndex };
  };

  resetPlaceholder = () => {
    this.setState({ agendaFlatFile: [] });
  };

  render() {
    const {
      props: { agendaList, momsStatus, agendaListDownload },

      state: {
        paginationNo,
        filterArrayName,
        sortStatus,
        agendaListParams,
        meetingDateFilterData,
        displayLoader,
        meetingDatecalender,
        filterTitle,
        calenderDisplaytext,
        cancel,
        PaginationData
      },
      onAgendaListDownload,
      onClearDownload
    } = this;
    ///console.log("333")

    let selectedFilters = this.excludeBasedOnFilteredData(
      [...filterArrayName],
      agendaList && agendaList.data.filters
    );

    const isUserPMG = getLocalstorage("groupCategory") === "PMG";

    const Option = props => {
      return (
        <div>
          <components.Option {...props}>
            <div class="checkbox-container-options">
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />{" "}
              <label>{props.label}</label>
            </div>
          </components.Option>
        </div>
      );
    };

    const MultiValue = ({ getValue }) => {
      const selectedCount = getValue().length;

      if (selectedCount > 0) {
        return `${selectedCount} selected`;
      }

      return null;
    };

    const selectStyle = {
      control: (baseStyles, state) => ({
        ...baseStyles,
        color: "#000000",
        height: "43px",
        fontFamily: "mpsb",
        "border-radius": "5px 0px 0px 5px",
        border: "1px solid #acacac",
        fontSize: "16px",
        lineHeight: "22px",
        width: "257px"
      }),
      option: (baseStyles, state) => ({
        ...baseStyles,
        backgroundColor: "white",
        fontSize: "14px",
        lineHeight: "18px",
        color: "#525252"
      })
    };

    let isPwaVersion = document.getElementsByClassName("pwa-btn");
    let isPwaIconExist =
      isPwaVersion.length > 0 ? "issue-list-heading-pwa" : "";
    return (
      <React.Fragment>
        <div className="content no-sidebar listpage-wrapper agenda-list">
          <div className="container">
            <div className={`issue-list-heading agenda-list ${isPwaIconExist}`}>
              <h1 className="page-heading" style={{ marginTop: "-2%" }}>
                PRAGATI Reviews{" "}
                {(get(PaginationData, "data.total") && (
                  <span>({get(PaginationData, "data.total")})</span>
                )) ||
                  null}
              </h1>

              <div className="issue-list-filter-right">
                <IssueSearchSorting
                  sortBy={sortByArr}
                  params={agendaListParams}
                  //defaultDates={dateFilter}
                  callApiOnSuccess={this.getAllPRAGATI}
                  pragaticss={true}
                  PRAGATI_LIST={get(this.state.PragatiList, "data.listDTO")}
                  onCalenderChange={this.handleCalendarFilterData}
                  calenderDisplaytext={calenderDisplaytext}
                  searchValue={this.state.searchValue}
                />
              </div>

              {/* <div className="common-list-heading-right" style={{marginTop:"-1.2%"}}>
                 <DownloadExcelReport
                    isLoading={
                      agendaListDownload && agendaListDownload.isLoading
                    }
                    downloadLink={
                      agendaListDownload && agendaListDownload.downloadingSrc
                    }
                    pragatiexcelcss={true}
                    onClearDownload={onClearDownload}
                    onStartDownloading={onAgendaListDownload}
                    resetPlaceholder={this.resetPlaceholder}
                  />
              </div> */}
            </div>
            <div className="issue-list-content">
              {/* <div className="issue-list-filter-wrapper">
                <Form>
                  <div className="issue-list-filters">
                    <div className="filter-header">
                      <div className="filter-title">
                        <Image src={IconFilter} alt="Filter Icon" />
                        <span>Filters</span>
                      </div>
                      {Object.values(agendaListParams).length > 2 ? (
                        <div className="clear-filter" onClick={this.clearAll}>
                          Clear All
                        </div>
                      ) : null}
                    </div>
                    {momsStatus === STATUS.LOADING ? (
                      <LoaderTemplate
                        parentClass={"filter-loader-project-list"}
                        children={<FilterLoader />}
                        height={300}
                        width={400}
                      />
                    ) : (
                      <FilterComponent
                        filtersValue={agendaListParams}
                        filterData={get(agendaList, "data.filters")}
                        onChange={this.handleCheckbox}
                      />
                    )}
                  </div>
                </Form>
              </div> */}
              <div className="issue-list-multiple" style={{ width: "100%" }}>
                {/* <div className="issue-list-exposed-filters">
                  <div className="issue-list-filter-right">
                    <IssueSearchSorting
                      sortBy={sortByArr}
                      params={agendaListParams}
                      //defaultDates={dateFilter}
                      callApiOnSuccess={this.getAllPRAGATI}
                    />
                  </div>
                </div> */}
                {filterTitle == "" || filterTitle == undefined ? null : (
                  <>
                    <div
                      class="applied-filter-list"
                      style={{ marginTop: "-1.5%" }}
                    >
                      <div class="applied-filter" style={{ marginBottom: 0 }}>
                        {filterTitle}
                        <span
                          class="close"
                          onClick={() =>
                            this.handleCalendarFilterData(
                              this.state.PRAGATI_LIST,
                              meetingDatecalender,
                              filterTitle,
                              cancel
                            )
                          }
                        >
                          X
                        </span>
                      </div>
                    </div>
                  </>
                )}

                {/* <div className="applied-filter-list">
                  {selectedFilters.map((item, index) =>
                    item.filterName !== undefined ? (
                      <div className="applied-filter" key={index}>
                        {item.displayName}
                        <span
                          className="close"
                          onClick={e => {
                            e.stopPropagation();
                            this.removeFilter(item);
                          }}
                        >
                          X
                        </span>
                      </div>
                    ) : (
                      <></>
                    )
                  )}
                </div> */}
                {get(PaginationData, "data") &&
                (agendaListParams && agendaListParams.offset > 0) ? (
                  <div className="add-space">
                    <Pagination
                      offset={agendaListParams.offset}
                      pageCount={
                        get(PaginationData, "data.total", 0) /
                        get(PaginationData, "data.limit", 0)
                      }
                      onPageChange={this.onPageChange}
                    />
                  </div>
                ) : null}
                <AgendaListWithLoader
                  //agendaList={meetingDatecalender?meetingDateFilterData:this.state.PRAGATI_LIST}
                  agendaList={this.state.PRAGATI_LIST}
                  isLoading={momsStatus}
                  paginationNo={paginationNo}
                  agendaListDto={agendaListParams}
                  calenderFilterloading={
                    meetingDatecalender ? displayLoader : false
                  }
                  paginationloading={this.state.paginationloading}
                />
                {get(PaginationData, "data") ? (
                  <Pagination
                    offset={agendaListParams.offset}
                    pageCount={
                      get(PaginationData, "data.total", 0) /
                      get(PaginationData, "data.limit", 0)
                    }
                    onPageChange={this.onPageChange}
                  />
                ) : null}
              </div>
            </div>
          </div>

          {/*For mobile*/}
          <div className="sort-section hidden-desktop">
            <div className={`sort-container ${sortStatus ? "visible" : ""}`}>
              <div className={`sort-popup ${sortStatus ? "visible" : ""}`}>
                <div className="popup-title">
                  Sort By
                  <button type="button" className="close">
                    <span aria-hidden="true" onClick={this.onHandleSort}>
                      ×
                    </span>
                  </button>
                </div>
                <div className="popup-body">
                  <ul>
                    <li>
                      <input
                        type="radio"
                        name="issue"
                        value="high"
                        onClick={e => {
                          e.stopPropagation();
                          this.onChangeSort("name");
                        }}
                      />{" "}
                      <b>Agenda</b>&nbsp;Name
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="issue"
                        value="low"
                        onClick={e => {
                          e.stopPropagation();
                          this.onChangeSort("latest");
                        }}
                      />{" "}
                      <b>Latest</b>&nbsp;Created
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="issue"
                        value="latest"
                        onClick={e => {
                          e.stopPropagation();
                          this.onChangeSort("old");
                        }}
                      />{" "}
                      <b>Old</b>&nbsp;Created
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/*For mobile*/}
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    agendaList: state.momReducer.momData,
    momsStatus: state.momReducer.momsStatus,
    agendaListDownload: state.donwloadExcelReducer.agendaListDownload
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadAgendaListAction,
      clearAgendaListDownloadAction,
      getAllPRAGATI: getAllPRAGATI
    },
    dispatch
  );
}

export default PermissionHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PragatiList)
);
